// Add aria-label to the elements
function addAriaLabels() {
    const dataLabels = document.querySelectorAll('[data-add-label]');
    dataLabels?.forEach(elm => {
        if(elm.hasAttribute('aria-label')) return;
        elm.setAttribute('aria-label', elm.dataset.addLabel);
    })
}

// Add link '<a>' to the elements as container
function addLinks() {
    const linkElms = document.querySelectorAll('[data-add-outer-link]');
    linkElms?.forEach(elm => {
        const href = elm.closest('[data-replo-product-handle]').dataset.reploProductHandle;
        if(!href) return;
        elm.removeAttribute('role');
        elm.removeAttribute('tabindex');
        const link = document.createElement('a');
        link.href = window.Shopify.routes.root + 'products/' + href;
        link.setAttribute('aria-label', 'View Product');
        elm.parentNode.insertBefore(link, elm);
        link.appendChild(elm);
    })
}


// Multi slide carousel gallery section
function multiSlidesSection() {
    const section = document.querySelector('[data-multi-slide-carousel]');
    const pictures = section?.querySelectorAll('picture[role]');
    pictures?.forEach(pic => {
        if(pic.hasAttribute('aria-label')) return;
        pic.setAttribute('aria-label', 'View Product');
    })
}


// check and remove aria-labelledby attribute 
function removeAriaLabelled() {
    const elms = document.querySelectorAll('[data-remove-attribute-labelled]');
    elms?.forEach(elm => elm.removeAttribute('aria-labelledby'));
}


// Homepage - Product images slider hotspot
function sliderHotspot() {
    const container = document.querySelector('[data-images-slider-hotspots]');
    if(!container) return;
    updateHotspotBtns();

    const slideIndexElm = container.querySelector('[data-active-slide] span');
    const observer = new MutationObserver(updateHotspotBtns);
    observer.observe(slideIndexElm, {characterData: true, subtree: true, childList: true});

    // check and update aria-attributes of slider hotspot buttons
    function updateHotspotBtns() {
        const activeSlideIndex = container.querySelector('[data-active-slide]').textContent.trim();
        const allSlides = container.querySelectorAll('[data-slide-container]');
        const activeSlide = allSlides[activeSlideIndex - 1];
        const hotspotBtns = activeSlide.querySelectorAll('[data-add-label]');

        hotspotBtns?.forEach(btn => {
            btn.setAttribute('tabindex', 0);
            btn.setAttribute('aria-hidden', 'false');
        })

        container.querySelectorAll('[data-add-label]')?.forEach(dot => {
            if(dot.closest('[data-slide-container]') !== activeSlide) {
                dot.setAttribute('tabindex', -1);
                dot.setAttribute('aria-hidden', 'true')
            }
        })
    }
}


document.addEventListener('DOMContentLoaded', () => {
    addAriaLabels();
    addLinks();
    removeAriaLabelled();
    multiSlidesSection();
    sliderHotspot();
})